import * as selectors from '../selectors';

const usefulProps = new Set(['title', 'content', 'hidden', 'educatorOnly']);

const onlyUsefulProps = (material) =>
  Object.keys(material)
    .filter((key) => usefulProps.has(key))
    .reduce((acc, key) => ({ ...acc, [key]: material[key] }), {});

const exporter = (state, educatorOnly = false) => ({
  version: 'v2',
  material: selectors
    .topLevelMaterials(state)
    .filter(
      (material) => Boolean(material.educatorOnly) === Boolean(educatorOnly)
    )
    .map((material) => ({
      ...onlyUsefulProps(material),
      pages: material.isFolder
        ? selectors.sectionsByParent(state, material.id).map(onlyUsefulProps)
        : undefined,
    })),
});

export default exporter;
